/**
 *
 * @param {Date} date
 * @returns
 */
export const getDateString = date => {
  return date
    .toLocaleDateString('ru-RU')
    .split('.')
    .reverse()
    .join('-')
}

export const getDefaultDate = () => {
  return getDateString(new Date())
}

export const getDefaultDateStart = () => {
  const now = new Date()

  return getDateString(new Date(now.getFullYear(), now.getMonth(), 1))
}

export const getDefaultDateEnd = () => {
  const now = new Date()

  return getDateString(new Date(now.getFullYear(), now.getMonth() + 1, 1))
}



// WEBPACK FOOTER //
// ./src/modules/events/domain/utils/date.js